import { useMirageAnalyticsContext } from "@mirage/analytics/AnalyticsProvider";
import {
  PAP_Select_Upsell,
  Select_Upsell,
} from "@mirage/analytics/events/types/select_upsell";
import {
  PAP_Shown_Upsell,
  Shown_Upsell,
} from "@mirage/analytics/events/types/shown_upsell";
import { EnvCtx } from "@mirage/service-environment-context/global-env-ctx";
import { useCallback, useRef } from "react";
import { TrialActionType } from "./types";

const getDefaultProperties: () => Shown_Upsell["properties"] = () => ({
  dashExperience: EnvCtx.dashExperience,
  upsellFeature: "dash_trial",
  upsellFormat: "notification",
});

export const useLogShownUpsellComponent = () => {
  const { reportPapEvent } = useMirageAnalyticsContext();
  const loggedRef = useRef(false);

  return useCallback(
    (propertyOverrides: Shown_Upsell["properties"]) => {
      if (!loggedRef.current) {
        loggedRef.current = true;
        reportPapEvent(
          PAP_Shown_Upsell({ ...getDefaultProperties(), ...propertyOverrides }),
        );
      }
    },
    [reportPapEvent],
  );
};

export const useLogSelectUpsellComponent = () => {
  const { reportPapEvent } = useMirageAnalyticsContext();
  const loggedRef = useRef(false);

  return useCallback(
    (propertyOverrides: Select_Upsell["properties"]) => {
      if (!loggedRef.current) {
        loggedRef.current = true;
        reportPapEvent(
          PAP_Select_Upsell({
            ...getDefaultProperties(),
            ...propertyOverrides,
          }),
        );
      }
    },
    [reportPapEvent],
  );
};

export const getActionSurface = (actionType: TrialActionType): string => {
  switch (actionType) {
    case TrialActionType.Chat:
      return "chat";
    case TrialActionType.Connector:
      return "connector";
    case TrialActionType.Stacks:
      return "stacks";
    case TrialActionType.Search:
      return "serp";
  }
};
